import { render, staticRenderFns } from "./TzsbJbxx.vue?vue&type=template&id=2111d6ff&scoped=true"
import script from "./TzsbJbxx.vue?vue&type=script&lang=js"
export * from "./TzsbJbxx.vue?vue&type=script&lang=js"
import style0 from "./TzsbJbxx.vue?vue&type=style&index=0&id=2111d6ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2111d6ff",
  null
  
)

export default component.exports